import { React, useState, useEffect } from 'react';
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from 'react-redux';
import 'react-notifications/lib/notifications.css';

import Header from 'src/layouts/Header';
import Footer from 'src/layouts/Footer';
import LoginForm from '../components/form/LoginForm';
import useSEO from 'src/hooks/useSEO';

const Login = () => {
  useSEO({
    title: 'Login - SphynxPlace.com',
    description: 'Sign in to your SphynxPlace account to manage your Sphynx cat listings and favorites.',
    robots: 'noindex, nofollow',
  });
  const navigate = useNavigate();
  const auth = useSelector((state) => state.auth);

  useEffect(() => {
    // Ako je korisnik već prijavljen, redirect-uj ga na home
    if (auth.isLoggedIn) {
      navigate('/', { replace: true });
    }
  }, [auth.isLoggedIn, navigate]);

  // Ako je korisnik prijavljen, ne prikazuj stranicu
  if (auth.isLoggedIn) {
    return null;
  }

  return (
    <>
      <Header />
      <div className="container mx-auto min-h-[calc(100vh-200px)] flex items-center justify-center py-8">
        <LoginForm />
      </div>
      <Footer />
    </>
  )
}

export default Login